export default __webpack_public_path__ + "media/color/aion-9d422ce5.svg";